// removed by extract-text-webpack-plugin
module.exports = {"valign":"_1J5IR4X7KuJxq06-aq_5c2","valignMiddle":"_2D1fuegOiXxswYHGNZ91W","valignBottom":"_2fs9E5S6prHnf0Uu_eqY5y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Valign/style.css
// module id = 221
// module chunks = 42